import { Injectable } from '@angular/core';
import { DispatcherModule } from '../dispatcher.module';
import { NgRedux } from '@angular-redux/store';
import { AppState } from '../state.model';
import { CommonActions } from './common-actions';

@Injectable({
  providedIn: DispatcherModule,
})
export class CommonDispatcher {
  constructor(
    private ngRedux: NgRedux<AppState>
  ) { }

  /**
  * @method setErrorCode sets the error code
  * @param errorCode error code
  **/
  setErrorCode(errorCode: string) {
    this.ngRedux.dispatch(CommonActions.setErrorCode(errorCode));
  }
  /**
   * @method setTableData sets the table data
   * @param tableColumns column values
   * @param tableDataSource data source
   **/
  setTableData(tableColumns: Array<string>, tableDataSource: Array<object>) {
    this.ngRedux.dispatch(CommonActions.setTableData(tableColumns, tableDataSource));
  }
  /**
  * @method setStep sets the step view or upload
  * @param step step
  **/
  setStep(step: string) {
    this.ngRedux.dispatch(CommonActions.setStep(step));
  }
  /**
  * @method setGetresposne sets the get response from the api
  * @param getResponse getResponse
  **/
  setGetresposne(response: object) {
    this.ngRedux.dispatch(CommonActions.setGetResponse(response));
  }
  /**
  * @method setFailedRecords sets the failed records recieved as response from the api
  * @param response getResponse
  **/
  setFailedrecords(response: object) {
    this.ngRedux.dispatch(CommonActions.setFailedRecords(response));
  }
  /**
  * @method resetAll resets everything
  **/
  public resetAll() {
    this.ngRedux.dispatch(CommonActions.resetAll());
  }
  /**
  * @method showResults shows results
  * @param showResults contains flag to show asi or package
  **/
  showResults(showResults: string) {
    this.ngRedux.dispatch(CommonActions.showResults(showResults));
  }
  /**
  * @method setProfile set the profile during search
  * @param setProfile vehicle or customer
  **/
  setProfile(profile: string) {
    this.ngRedux.dispatch(CommonActions.setProfile(profile));
  }
}
